import React from 'react';

interface ShareLinkProps {
  handleClick: () => void;
}

export const WINDOW_VARIABLES = 'resizable=yes, top=200, left=500, width=500, height=300';

export const ShareLink: React.FC<ShareLinkProps> = ({ handleClick, children, ...rest }) => (
  <button className="ShareLink" onClick={handleClick} onKeyPress={handleClick} {...rest}>
    {children}
  </button>
);
